import { useEffect, useState } from "react";

function prefersReducedMotion() {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/**
 * Rotaciona um array de mensagens a cada `intervalMs`. Quando há somente
 * uma mensagem, ou o usuário pediu motion reduzido, retorna a primeira
 * fixa (sem timer).
 */
export function useRotatingMessages(messages, intervalMs = 2000) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!messages || messages.length <= 1) return undefined;
    if (prefersReducedMotion()) return undefined;
    const id = setInterval(() => {
      setIndex((current) => (current + 1) % messages.length);
    }, intervalMs);
    return () => clearInterval(id);
  }, [messages, intervalMs]);

  if (!messages || messages.length === 0) return "Carregando...";
  return messages[index % messages.length];
}
